/**
 * Gestion du cookie cqSource pour le tracking de la source des visiteurs
 */
document.addEventListener('DOMContentLoaded', function() {
    const cqSource = Utils.getCookie("cqSource");
    let source = window.location.search.substr(1); // correspond au GET

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const referrer = document.referrer;
    const domain = referrer.indexOf('satellifacts.com');

    const utm_source = urlParams.get('utm_source');
    const cqad = urlParams.get('cqad');

    if (!cqSource) {
        if (!referrer && domain === -1) { // Vérifier si le domaine est satellifacts ou non
            source = document.referrer;
            if (utm_source === "Alertes") {
                source = "ALERTE SATELLIFACTS (" + document.referrer + ")";
            } else if (utm_source === "Newsletter hebdo") {
                source = "NEWSLETTER SATELLIFACTS (" + document.referrer + ")";
            } else if (source.match(/^https?:\/\/www\.satellifacts\.com/g)) {
                source = "SATELLIFACTS (" + document.referrer + ")";
            }
            Utils.setCookie('cqSource', source, 90); // 90 jours d'expiration
        }

        if (!utm_source) {
            source = document.referrer;
            if (source.match(/linkedin/g)) {
                source = "LINKEDIN (" + document.referrer + ")";
            }

            if (cqad == 1) {
                source = "PUBLICITE GOOGLE ( Google ADS )";
            } else if (source.match(/google/g)) {
                source = "GOOGLE (" + document.referrer + ")";
            }
            if (!source) {
                source = "URL saisie par le client";
            }
            Utils.setCookie('cqSource', source, 90); // 90 jours d'expiration
        }
    }
});
